import { Pipe, PipeTransform } from '@angular/core';

/**
 * Shows a percentage as "65%". The API returns some rates pre-formatted the
 * Turkish way ("%65"), and the UI is English/German, so normalise both
 * numbers and "%"-prefixed strings to a trailing percent sign.
 */
@Pipe({
  name: 'pct',
  standalone: false
})
export class PercentSuffixPipe implements PipeTransform {
  transform(value: unknown, digits?: number): string {
    if (value === null || value === undefined || value === '') return '-';
    const raw = String(value).replace('%', '').trim();
    const num = Number(raw);
    if (raw === '' || Number.isNaN(num)) return String(value);
    return (digits === undefined ? raw : num.toFixed(digits)) + '%';
  }
}
